/**
 * Service to manage manually followed competitors and their deep metadata.
 */
import { YouTubeVideo } from "./youtubeAdvanced";
import { dummyCompetitorVideos } from "./dummyData";

export interface FollowedCompetitor {
  id: string;
  name: string;
  url: string;
  addedAt: string;
}

const STORAGE_KEY = "yt_followed_competitors";

export const getFollowedCompetitors = (): FollowedCompetitor[] => {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [
    { id: "ch_comp1", name: "VidIQ", url: "youtube.com/@vidiq", addedAt: new Date().toISOString() },
    { id: "ch_comp2", name: "TubeBuddy", url: "youtube.com/@tubebuddy", addedAt: new Date().toISOString() }
  ];
};

export const addCompetitor = (name: string, url: string) => {
  const comps = getFollowedCompetitors();
  const newComp: FollowedCompetitor = {
    id: `comp_${Date.now()}`,
    name,
    url,
    addedAt: new Date().toISOString()
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...comps, newComp]));
  return newComp;
};

export const fetchCompetitorContent = async (apiKey: string, competitorId: string): Promise<(YouTubeVideo & { tags: string[] })[]> => {
  if (!apiKey || apiKey === "YOUR_GOOGLE_API_KEY") return dummyCompetitorVideos;

  try {
     // 1. Get recent videos (simplified for now, usually would be search/list)
     const response = await fetch(
       `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${competitorId}&order=date&type=video&maxResults=5&key=${apiKey}`
     );
     const data = await response.json();
     if (!data.items) return [];

     const videoIds = data.items.map((i: any) => i.id.videoId).join(",");

     // 2. Get Deep Metadata (Tags, Description)
     const videoRes = await fetch(
       `https://www.googleapis.com/youtube/v3/videos?part=snippet,statistics&id=${videoIds}&key=${apiKey}`
     );
     const videoData = await videoRes.json();

     return videoData.items.map((v: any) => ({
       id: v.id,
       title: v.snippet.title,
       description: v.snippet.description,
       thumbnail: v.snippet.thumbnails.medium.url,
       publishedAt: v.snippet.publishedAt,
       tags: v.snippet.tags || [],
       viewCount: v.statistics.viewCount
     }));
  } catch (err) {
    console.error("Error fetching deep competitor data:", err);
    return [];
  }
};
